"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
const capacity_1 = __importDefault(require("../../MockData/capacity"));
class CapacityInitializer extends AbstractInitializer_1.default {
    constructor(cache, userRepository, capacityModel) {
        super("capacity_initializer", cache);
        this.initialize = async () => {
            const capacityValues = {};
            await (0, asyncIterate_1.default)(await this.userRepository.all(), async (user) => {
                capacityValues[user.id] = capacity_1.default;
            });
            await this.capacityModel.setCapacities(capacityValues);
        };
        this.userRepository = userRepository;
        this.capacityModel = capacityModel;
    }
}
exports.default = CapacityInitializer;
//# sourceMappingURL=CapacityInitializer.js.map